module.exports = __webpack_public_path__ + "static/media/SFProText-HeavyItalic.36abf927.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-HeavyItalic.ttf
// module id = 2557
// module chunks = 7